import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
  state: {
    userList: [],
  },
  mutations: {},
  actions: {
    async getShortTermJobList(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/getShortTermJobList`, data)

          if (!result.data.errorCode || result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async getShortTermJobDetail(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/getShortTermJobDetail`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async createShortTermJob(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/createShortTermJob`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async updateShortTermJob(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/updateShortTermJob`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {

          reject(err)
        }
      })
    },
    async deleteShortTermJob(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/deleteShortTermJob`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {

          reject(err)
        }
      })
    },
  },
  getters: {}
}

export default moduleStore;